import { NgModule } from '@angular/core';
import { MdSelectModule } from '@angular/material';
import { SharedModule } from '../../shared/shared.module';
import { MomentModule } from 'angular2-moment';
import { DatePickerModule} from '../../components/date-picker/date-picker.module';


import { ManageBookingComponent } from './manage-booking/manage-booking.component';
import { BookingRoutingModule } from './booking.routing';
import { BookingDetailsPopupComponent } from './booking-detail/booking-detail.component';
import { RequestAppointmentComponent } from './request-appointment/request-appointment.component';
import { BookingDetailsFluVaccinePopupComponent } from './booking-detail/booking-detail-fluvaccine.component';
import { ListMemberComponent } from './list-member/list-member.component';
import { AddMemberPopupComponent } from './list-member/add-member-popup.component';
import { AddTMBStaffPopupComponent } from './list-member/add-tmb-staff-popup.component';
import { ClinicSchedulePopupComponent } from './manage-booking/clinic-schedule-popup.component';

@NgModule ({
    declarations: [
        ManageBookingComponent,
        BookingDetailsPopupComponent,
        RequestAppointmentComponent,
        BookingDetailsFluVaccinePopupComponent,
        ListMemberComponent,
        AddMemberPopupComponent,
        AddTMBStaffPopupComponent,
        ClinicSchedulePopupComponent
    ],
    imports: [
        SharedModule,
        MomentModule,
        DatePickerModule,
        BookingRoutingModule
    ],
    entryComponents: [
        BookingDetailsPopupComponent,
        BookingDetailsFluVaccinePopupComponent,
        AddMemberPopupComponent,
        AddTMBStaffPopupComponent,
        ClinicSchedulePopupComponent
    ],
    providers: [],
    bootstrap: []
})

export class BookingModule { }


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/booking.module.ts